import { Component, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import {
  IFilterData,
  IProductPayload,
  IProductsPayload,
  ISortType,
} from "./../../../shared/models";
import {
  ApiService,
  CacheService,
  EventEmitterService,
  MatDialogUtilsService,
  SeoService,
  UtilsService,
} from "./../../../shared/services";
import { SCROLL_ICON_SHOW_DURATION } from "./../../../shared/constants";
import { ActivatedRoute, NavigationEnd, Params, Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
} from "@angular/cdk/layout";
import { first } from "rxjs/operators";
import MetaData from "../../../shared/services/seo/meta-data-model";
import { HttpParams } from "@angular/common/http";
import { EnvService } from "../../../shared/services/env.service";
import { Options } from "ng5-slider";
import { isArray } from "util";
import { CookieService } from "ngx-cookie-service";
import { MatDialog } from "@angular/material/dialog";
import { QuizDialogComponent } from "../quiz-dialog/quiz-dialog.component";
import { NoopScrollStrategy } from "@angular/cdk/overlay";
import { NgxMasonryComponent } from "ngx-masonry";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { ImageSearchDialogComponent } from "src/app/shared/components/image-search-dialog/image-search-dialog.component";

@Component({
  selector: "app-product-keyword-mapping",
  templateUrl: "./product-keyword-mapping.component.html",
  styleUrls: ["./product-keyword-mapping.component.less"],
})
export class ProductKeywordMappingComponent implements OnInit, OnDestroy {


  interval: ReturnType<typeof setInterval> | undefined;
  isFetched = false;
  isUpdating = false;
  spinner = "assets/image/spinner.gif";
  dummyProductListings: any[] = [];
  productListings: any[] = [];
  query: string;
  productsInRow = 2;

  page: number = 0;
  sorting: { sortBy: string; direction: any } = {
    sortBy: "",
    direction: "",
  };
  sortBy: string = "";
  sortType: string = "newest_first";
  currentResponseLength: number = 0;

  bpObserver: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Handset
  );
  bpSubscription: Subscription;
  isHandset = false;
  slideIndex = 0;

  showBottomPanel = true;
  item: any;
  height: number;
  keyword: string;
  products: IProductPayload[];

  totalCount = 0;
  isProductFetching: boolean;
  total = 24;
  sortTypeList: any[] = [
    {
      "name": "Top Picks",
      "value": "recommended",
      "enabled": false
    },
    {
      "name": "Price: Low to High",
      "value": "price_low_to_high",
      "enabled": false
    },
    {
      "name": "Price: High to Low",
      "value": "price_high_to_low",
      "enabled": false
    },
    {
      "name": "Newest First",
      "value": "newest_first",
      "enabled": false
    }
  ];
  pageNo: number;

  productsSubscription: Subscription;

  showMobileSort: boolean;

  routeSubscription: Subscription;
  showLoader: boolean;
  innerWidth: number;
  assetBaseUrl: string;
  productsLoading: boolean;
  public Math: Math = Math;
  throttle = 100;
  scrollDistance = 1;
  scrollUpDistance = 2;
  gridView = true;

  noProducts: boolean;

  private originalOffsetTop!: number;
  private isFixed = true;

  pageWidth: number;
  totalProducts: number;
  @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;

  productListingSubscription: Subscription;
  reachedLastPage: boolean;

  topPosToStartShowing = 300;
  fixFilterBar = 150;
  isIconShow = false;
  showBar = false;
  timeout: any;
  width: number;
  @ViewChild('bottomSheet') bottomSheet: TemplateRef<any>;
  filterQuery: string;
  callSearchProducts: Subscription;
  productDetails: any;


  constructor(
    public api: ApiService,
    private breakpointObserver: BreakpointObserver,
    public env: EnvService,
    private router: Router,
    private location: Location,
    public utils: UtilsService,
    private activeRoute: ActivatedRoute,
    private eventEmitterService: EventEmitterService,
    private matDiaService: MatDialogUtilsService,
    private matSnackbar: MatSnackBar,
    private dialog: MatDialog,
    public _bottomSheet: MatBottomSheet,

  ) {
    const possibleHeights = ['200px', '250px', '280px', '300px', '350px', '400px'];

  this.dummyProductListings = Array.from({ length: 12 }, () => ({
    displayable: true,
    main_image: '',
    height: possibleHeights[Math.floor(Math.random() * possibleHeights.length)]
  }));

    this.productListings = this.dummyProductListings;

    if (
      this.activeRoute.snapshot.routeConfig.path.includes("products/sale") ||
      this.activeRoute.snapshot.routeConfig.path.includes("sale")
    ) {
      this.keyword = "sale";
    } else if (
      this.activeRoute.snapshot.routeConfig.path.includes("products/new")
    ) {
      this.keyword = "new";
    } else {
      this.keyword = this.activeRoute.snapshot.params.keyword;
    }
    this.bpSubscription = this.bpObserver.subscribe(
      (handset: BreakpointState) => {
        this.isHandset = handset.matches;
      }
    );
    this.pageWidth = document.body.clientWidth;

  }


  ngOnInit() {
    this.innerWidth = window.innerWidth;

    this.height = window.innerHeight;
    this.width = window.innerWidth;
    this.assetBaseUrl = this.env.assetSLBaseUrl;
    this.sorting.sortBy = 'asc';
    this.sorting.direction = 'newest_first';
    this.sortType = 'newest_first';
    const id = JSON.parse(localStorage.getItem("user"))?.id;
    if (!id) {
      this.eventEmitterService.userChangeEvent.subscribe(() => {
        this.getParamsFromQuery();
      });
    } else {
      this.getParamsFromQuery();
    }

  }

  ngOnDestroy() {
    this.eventEmitterService.userChangeEvent?.unsubscribe();
  }



  ngAfterViewInit() {

    const filterBar = document.getElementById('filterBar');
    if (filterBar) {
      this.originalOffsetTop = filterBar.offsetTop;
      this.onWindowScroll()
    }
  }
  reloadMasonry(e) {
    if (this.masonry !== undefined) {
      this.masonry.reloadItems();
      this.masonry.layout();
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const filterBar = document.getElementById('filterBar');
    if (!filterBar) return;

    const scrollPosition = window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

      const pad =  (this.getcontentWidth ) ? 
        ((this.pageWidth-this.getcontentWidth)/2)+'px' : '0px';

    if (scrollPosition >= this.originalOffsetTop && !this.isFixed) {
      this.isFixed = true;
      filterBar.style.position = 'fixed';
      filterBar.style.top = '0';
      filterBar.style.width = this.pageWidth + 'px';
      filterBar.style.left =  '0px'

      filterBar.style.background = '#fff';
      filterBar.style.zIndex = this.isHandset ? '99' : '1';
      filterBar.style.marginTop = '0px';
      filterBar.style.height = this.isHandset? '108px': 'auto';
      filterBar.style.padding = `12px ${pad}`;
      filterBar.style.boxShadow = '0 4px 4px -2px rgba(0, 0, 0, 0.2)';
      filterBar.style.transition = 'border 0.2s, box-shadow 0.2s, background-color 0.2s';
    } else if (scrollPosition < this.originalOffsetTop && this.isFixed) {
      filterBar.style.position = 'static';
      filterBar.style.marginTop = '0px';
      filterBar.style.width = 'auto';
      filterBar.style.padding = `12px 0px`;
      filterBar.style.boxShadow = 'none';

      this.isFixed = false;
    }

    this.isIconShow = scrollPosition >= this.topPosToStartShowing;
    this.showBar = scrollPosition >= this.fixFilterBar;
    const self = this;
    if (this.isIconShow) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        self.isIconShow = false;
      }, SCROLL_ICON_SHOW_DURATION);
    }
  }

  get getcontentWidth(): number {
    return document.getElementById('contentWidth')?.clientWidth;
  }

  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }


  @HostListener("window:resize")
  onResize() {
    this.height = window.innerHeight;
    this.width = window.innerWidth;
    this.pageWidth = document.body.clientWidth;

  }


  getParamsFromQuery(): void {
    const routeConfig = this.activeRoute.routeConfig.path;

    this.routeSubscription = this.activeRoute.queryParams.subscribe(
      (params) => {

        this.query = params.query || "";


        this.pageNo = parseInt(params.pageNo) || 0;
        this.filterQuery = params.filters || '';
        this.sortType = params.sortType || "";
        this.sorting.direction = this.sortType;
        if (this.query) {
          this.pageNo = 0;
          this.search();
        } else {
          this.getProductListing(this.pageNo);
          setTimeout(() => {
            if (this.masonry !== undefined) {
              this.masonry.reloadItems();
              this.masonry.layout();
            }
          }, 1000);
        }

      }
    );
  }

  async getProductListing(page = 0, isFilter?) {
  this.isUpdating = true;
  this.noProducts = false;

  this.productListingSubscription = this.api
    .getAllProductsUsingKeyword(
      this.keyword,
      this.total,
      this.filterQuery,
      this.sortType,
      page
    )
    .subscribe(
      async (response: any) => {  // <-- make callback async
        if (response.status === "Unauthorised") {
          this.isFetched = true;
          this.isUpdating = false;
          const width = this.isHandset ? "90%" : "35%";
          this.matDiaService.openSigninDialog(width, true);
          this.productsLoading = false;

        } else if (response.products.length === 0) {
          this.isFetched = true;
          this.isUpdating = false;
          if (response.total === 0) this.noProducts = true;

        } else {
          this.totalProducts = response.total;

          // ✅ Wait until images are validated
          const validatedProducts = await this.processProducts(response);

          this.productsLoading = false;
          this.productListings = this.productListings.filter(f => !f.height);

          if (page === 0) {
            this.productListings = [...validatedProducts];
          } else {
            this.productListings = [...this.productListings, ...validatedProducts];
          }

          this.isFetched = true;
          this.isUpdating = false;
          this.currentResponseLength = validatedProducts.length;
          this.updateQueryString();
        }
      },
      (err) => {
        this.productsLoading = false;
        this.matSnackbar.open('Error fetching results', 'x', { duration: 7000 });

        if (err.error.status === "Unauthorised") {
          this.isFetched = true;
          this.isUpdating = false;
          const width = this.isHandset ? "90%" : "35%";
          this.matDiaService.openSigninDialog(width, true);
        }
      }
    );
}

  // Utility function: checks if an image is accessible


// Inside your service/component where you handle response
async processProducts(response: any) {
  const products = response.products.map((product: any) => {
    return {
      ...product,
      product_condition: product.condition,
      mainImage: product.main_image,
      discount:
        product.percent_discount &&
        product.percent_discount !== '0.00' &&
        +product.percent_discount > 0 &&
        product.percent_discount !== '0'
          ? parseInt(product.percent_discount)
          : '',
      isMainImageAccessible: false // temporary, will update after check
    };
  });

  // Check all images in parallel
  const checks = products.map(async (p) => {
    p.isMainImageAccessible = await this.api.checkImageAccessible(p.mainImage);
    return p;
  });

  // Wait until all checks are done
  const validatedProducts = await Promise.all(checks);

  console.log('✅ Final validated products', validatedProducts);
  return validatedProducts;
}


  loadMore() {
    this.page++;
    this.getProductListing(this.page);
  }
 
 

  setSorting(newSortBy: string) {
    if (this.sorting.sortBy === newSortBy) {
      this.sorting.direction =
        this.sorting.direction === "asc" ? "desc" : "asc";
    } else {
      this.sorting.sortBy = newSortBy;
      this.sorting.direction = "asc";
    }
    this.getProductListing();
  }

  toggleSort(newSortType: string) {
    this.sortType = newSortType;
    this.getProductListing();
  }

  openImageInNewTab(imageUrl: string) {
    window.open(imageUrl, "_blank");
  }

  openProductInNewTab(productUrl: string) {
    this.router.navigate([]).then(() => {
      window.open(`product/${productUrl}`, "_blank");
    });
  }



  updateQueryString(): void {
    let params: string[] = [];


    if (this.filterQuery) {
      // params.push(`filters=${encodeURIComponent(this.filterQuery)}`);
      params.push(`filters=${encodeURI(this.filterQuery)}`);

    }
    if (this.sortType) {
      params.push(`sortType=${encodeURIComponent(this.sortType)}`);
    }

    if (this.query) {
      params.push(`query=${encodeURIComponent(this.query)}`);
    }
  if(this.api.imgSearchData && this.api.imgSearchData.image_url) {
      params.push(`image_url=${encodeURIComponent(this.api.imgSearchData.image_url)}`);
    }
    // Append pageNo LAST
    if (this.page) {
      params.push(`pageNo=${encodeURIComponent(this.page.toString())}`);
    } else {
      params = params.filter(p => !p.startsWith("pageNo="));
    }

    this.location.replaceState(
      window.location.pathname,
      params.join("&"),

      this.location.getState()
    );
  }


  onSetSortType(e): void {

    this.sortType = e;
    this.sorting.sortBy = e === 'price_high_to_low' ? 'desc' : 'asc';
    this.sorting.direction = e;
    // this.pageNo=0;
    this.productListings = [];
    this.getProductListing();
    setTimeout(() => {
      if (this.masonry !== undefined) {
        this.masonry.reloadItems();
        this.masonry.layout();
      }
    }, 1000);

  }



  onSetSortToggle($e): void {
    this.toggleMobileSort();
  }



  toggleMobileSort() {
    this.showMobileSort = !this.showMobileSort;
  }

  productInfo: any;
  isVariationCallLoading: boolean;
  isVariationExist: boolean;
  variations: any;
  hasSelection: any;
  newVariationFound: boolean;
  paramSku: string;
  loadDetails = false;

  navigateTo(product: any) {
    window.open(`/product/${product.sku}`, "_blank");

  }

  onAllScrollDown() {
    if (!this.query) {
      if(this.productListings.some(f=>f.height)) return;
      if (this.currentResponseLength === 24){
        this.productListings.push(...this.dummyProductListings)
        setTimeout(() => {
          this.loadMore();
        }, 1000);
      // setTimeout(() => {
      //   if (this.masonry !== undefined) {
      //     this.masonry.reloadItems();
      //     this.masonry.layout();
      //   }
      // }, 1000);
      }

    } else {
      if (!this.isFetched || this.reachedLastPage) return;
      this.pageNo = this.pageNo + 1;
      this.productListings.push(...this.dummyProductListings);
      this.search();
      setTimeout(() => {
        if (this.masonry !== undefined) {
          this.masonry.reloadItems();
          this.masonry.layout();
        }
      }, 1000);
    }
  }


  searchNewProduct() {
    this.pageNo = 0;
      if (this.callSearchProducts) {
      this.callSearchProducts.unsubscribe();
    }
    this.search();
  }

  search() {
    if (this.pageNo === 0 || this.pageNo === -1) { this.productListings = this.dummyProductListings; }
    this.totalProducts = -1;
    this.isFetched = false;
    this.reachedLastPage = false;
    let call: any;
    if (this.api.imgSearchData) {
      call = this.api.searchProducts('', this.pageNo+1, this.api.imgSearchData)
    } else {
     
      call = this.api
        .searchProducts(this.query, this.pageNo+1, null)
    }

    this.callSearchProducts = call.subscribe(
      (response: any) => {
        const items = response.page_size * response.total_pages;
        this.reachedLastPage = (this.pageNo + 1) === response.total_pages;
        this.totalProducts = items;
        if (response.status === "Unauthorised") {
          this.isFetched = true;
          this.isUpdating = false;
          const width = this.isHandset ? "90%" : "35%";
          const data = this.matDiaService.openSigninDialog(width, true);
          data.afterClosed((res) => {
          });
          this.productsLoading = false;

        } else if (response.results.length === 0) {
          this.isFetched = true;
          this.isUpdating = false;
          if (items === 0) this.noProducts = true;

        } else {
          response.results.forEach((product: any) => {

            product["checked"] = false;
            product["isMainImageAccessible"] = true;
            product["allImages"] = [];
            if (product["main_product_images"]) {
              product["allImages"].push(
                product["main_product_images"].split(",")
              );
            }
            if (product["product_images_gallery"]) {
              product["allImages"].push(
                product["product_images_gallery"].split(",")
              );
            }
            product["allImages"] = product["allImages"].flat();
            product["product_feature"] = this.utils.compileMarkdown(
              product.feature
            );

            product['main_image'] =
              product.allImages[0] ? (this.assetBaseUrl + product.allImages[0]) : 'test';

              if(product['main_image']==='test'){
                product['isMainImageAccessible'] = false;
              }

            //  product['main_image'] = this.assetBaseUrl + product.allImages[0];
            product['name'] = product.product_name;
          });
          this.productsLoading = false;
          this.productListings = this.productListings.filter(f => !f.height);
          if (this.pageNo === 0) {
            this.productListings = [];
            this.productListings = [...this.productListings, ...response.results];
          } else {
            this.productListings = [...this.productListings, ...response.results];
          }
          this.isFetched = true;
          this.isUpdating = false;
          this.currentResponseLength = response.results.length;
          this.updateQueryString();


        }


      },
      (err) => {
        this.productsLoading = false;
        this.matSnackbar.open('Error fetching results', 'x', { duration: 7000 })
        if (err.error.status === "Unauthorised") {
          this.isFetched = true;
          this.isUpdating = false;
          const width = this.isHandset ? "90%" : "35%";
          const data = this.matDiaService.openSigninDialog(width, true);
          data.afterClosed((res) => {
          });
        }
      }
    );

  }

  resetQuery() {
    this.query = '';
    this.totalProducts = -1;

    this.getProductListing();
  }



  getProductData(product: any) {
    this.closeProductNav('');
    this.productDetails = product;
    this.paramSku = product.sku;
    this.loadDetails = true;

    if (this.isHandset) {
      this.openBottomSheet();
    } else {
      this.openProductNav();
    }
  }

  openBottomSheet() {
    // this.isPrdPreviewOpened=true;
    this._bottomSheet.open(this.bottomSheet);
  }

  openProductNav() {
    document.getElementById("productSidenav").style.width = "450px";
    document.getElementById('productSidenav').scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    // this.api.isSideNavOpened = true;
  }

  closeProductNav(msg) {
    if (document.getElementById("productSidenav")) {
      this.loadDetails = false;
      document.getElementById("productSidenav").style.width = "0";
      document.body.style.backgroundColor = "white";
      if (msg !== 'close' && msg) {
        this.matSnackbar.open(msg, 'x', { duration: 3000 })
      }
      // this.api.isSideNavOpened = false;
    }
  }
  openNav() {
    document.getElementById("mySidenav").style.width = this.isHandset ? this.width+'px': "650px";
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    this.api.isSideNavOpened = true;
  }

  closeNav() {
    if (document.getElementById("mySidenav")) {
      document.getElementById("mySidenav").style.width = "0";
      document.body.style.backgroundColor = "white";
      this.api.isSideNavOpened = false;
    }
  }

  reloadProducts(filterUrl) {
    if (this.productListingSubscription) {
      this.productListingSubscription.unsubscribe();
    }

    this.filterQuery = filterUrl;
    this.productListings = this.dummyProductListings;
    this.pageNo=0;
    this.page=0;
    this.updateQueryString();
    this.getProductListing(0);
  }

  openImageDialog() {
    this.dialog.open(ImageSearchDialogComponent, {
      width: '700px',
      panelClass: 'image-search-dialog'
    })
  }

  onImageSearch() {
    this.searchNewProduct();

  }

}
